import React, { Component } from 'react';
import { Checkbox } from 'semantic-ui-react';
import ReactTable from 'react-table';

import { SchoolCalendarFieldEnum as Fields } from 'Common/FieldEnum';
import { TrackedCheckbox } from 'Components';

class AssignmentTable extends Component {
  columns = [
    {
      Header: 'Site Id',
      accessor: Fields.SiteMasterId,
      filterable: true,
      sortable: true,
      maxWidth: 120,
    },
    {
      Header: 'Site Description',
      accessor: Fields.SiteDescription,
      filterable: true,
      sortable: true,
    },
    {
      Header: 'Site Group',
      accessor: Fields.SiteGroup,
      filterable: true,
      sortable: true,
    },
    {
      Header: 'Assigned Calendar',
      accessor: Fields.AssignedCalendar,
      filterable: true,
      sortable: true,
    },
    {
      Header: ({ data }) => {
        const { isReadOnly, onToggleAll, mbeComplete } = this.props;

        return (
          <Checkbox
            checked={data.length > 0 && data.every(s => s._original.Assigned)}
            onClick={e => onToggleAll(data)}
            disabled={isReadOnly || mbeComplete}
          />
        );
      },
      accessor: Fields.Assigned,
      maxWidth: 120,
      filterable: false,
      sortable: false,
      Cell: ({ original, index }) => {
        const { isReadOnly, initialData, onToggle, mbeComplete } = this.props;
        const initialValue = initialData.find(
          x => x.SiteMasterId === original.SiteMasterId
        ).Assigned;

        return (
          <div className={'text-center'}>
            <TrackedCheckbox
              initialValue={initialValue}
              checked={original.Assigned}
              disabled={isReadOnly || (initialValue && mbeComplete)}
              onChange={() => onToggle(index)}
            />
          </div>
        );
      },
    },
  ];

  render() {
    const { assignments, loading } = this.props;

    return (
      <ReactTable
        className={'grid--fixed-row-height'}
        columns={this.columns}
        data={assignments}
        loading={loading}
        minRows={10}
        pageSize={10}
        showPageJump={false}
        showPageSizeOptions={false}
      />
    );
  }
}

export { AssignmentTable };



// WEBPACK FOOTER //
// ./src/pages/schoolcalendar/components/AssignmentTable.js